module.exports = __webpack_public_path__ + "img/yuyue-y.0885d056.svg";